var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"banner",style:({ height: `${(_vm.headerInfo.headerHeight || 320) / 200}rem` })},[_c('img',{attrs:{"src":_vm.headerInfo.headerImgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }